import type { CaseOverview } from "@exploitlens/ui-contracts";

import { shortCommit, shortHex } from "../../lib/format";
import { VerdictBadge } from "./VerdictBadge";

export function CaseIdentity({ overview }: { overview: CaseOverview }) {
  return (
    <section aria-labelledby="case-identity-heading">
      <div className="flex flex-wrap items-center justify-between gap-4">
        <h1 id="case-identity-heading" className="font-editorial text-3xl text-ink">
          {overview.caseId}
        </h1>
        <VerdictBadge verdict={overview.verdict} />
      </div>

      <dl className="mt-6 grid grid-cols-1 gap-x-8 gap-y-3 text-sm sm:grid-cols-2">
        <div>
          <dt className="text-ink-faint">Baseline commit</dt>
          <dd className="font-evidence text-ink" title={overview.baselineCommit}>
            {shortCommit(overview.baselineCommit)}
          </dd>
        </div>
        <div>
          <dt className="text-ink-faint">Patched commit</dt>
          <dd className="font-evidence text-ink" title={overview.patchedCommit}>
            {shortCommit(overview.patchedCommit)}
          </dd>
        </div>
        <div>
          <dt className="text-ink-faint">Frozen manifest hash</dt>
          <dd className="font-evidence text-ink" title={overview.manifestHash}>
            {shortHex(overview.manifestHash)}
          </dd>
        </div>
        <div>
          <dt className="text-ink-faint">Generated</dt>
          <dd className="text-ink">{overview.generatedAt}</dd>
        </div>
        <div>
          <dt className="text-ink-faint">Declared invariant</dt>
          <dd className="text-ink">{overview.invariant.description}</dd>
        </div>
        <div>
          <dt className="text-ink-faint">Declared exploit effect</dt>
          <dd className="text-ink">
            {overview.expectedExploit.effectType}
            {overview.expectedExploit.asset ? ` · ${overview.expectedExploit.asset}` : ""}
          </dd>
        </div>
      </dl>
    </section>
  );
}
